import { render, staticRenderFns } from "./SortableFirmwideEmissionByProductFamily.vue?vue&type=template&id=73edc857"
import script from "./SortableFirmwideEmissionByProductFamily.vue?vue&type=script&lang=js"
export * from "./SortableFirmwideEmissionByProductFamily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports